import React from 'react';


export default () => {
  const iframe = React.useRef();
  
  React.useEffect(() => {
    return () => {
      if (iframe.current?.parentNode) {
        iframe.current.parentNode.removeChild(iframe.current);
        
        iframe.current = null;
      }
    };
  }, []);
  
  return (link) => {
    if (!link)
      return;
    
    if (!iframe.current) {
      iframe.current = document.createElement('iframe');
      iframe.current.id = 'print-document';
      iframe.current.style = 'overflow-y: hidden; position: absolute; top: 0px; left: -9999px; line-height: normal; text-decoration: none; letter-spacing: 0px;';
      document.body.appendChild(iframe.current);
    }
    
    iframe.current.src = '';
    iframe.current.src = link;
  };
};
